// @owners { team: patients }
import { type DeliveryWithPrescription } from '~shared/types';

export const isInProgressMedSync = (delivery: DeliveryWithPrescription) => {
  // returns true only if delivery is part of an in progress med sync plan
  // this returns false if med_sync_status === 'final_sync' because that means that the prescription is on AutoRefill
  return delivery.med_sync_status === 'short_fill' || delivery.med_sync_status === 'in_progress';
};
